/* eslint-disable no-undef */
import axios, { AxiosInstance } from "axios";
import { cookieStorage } from "../../utils/cookieStorage";

const baseURL = process.env.REACT_APP_API_URL as string;

const axiosInstance: AxiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.request.use(
  function (config) {
    const token = cookieStorage.getItemSync("token");
    const appVersion = cookieStorage.getItemSync("appVersion") ?? "";

    config.headers = {
      ...config.headers,
      authorization: `Bearer ${token}`,
      "X-Client-Source": "WebPortal",
      "X-App-Version": appVersion,
    };

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error({ error });
    const token = cookieStorage.getItemSync("token");
    const errorMessage = error?.response?.data.message;
    if (
      error.response.status === 401 &&
      (errorMessage === "Token is expired" ||
        errorMessage === "Unauthorized") &&
      !!token &&
      "/login" !== window.location.pathname
    ) {
      cookieStorage.removeItemSync("token");
      window.location.href = "/login?expired=true";
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
